import SwitchYesNoWithLabel from "components/app/function/SwitchYesNoWithLabel";
import { ShimmerDialogEditProduct } from "components/app/shrimmer/Shrimmer";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { ImageUp, Loader, Minus, Plus, Trash2, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import appStore from "store/appStore";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Textarea } from "components/ui/textarea";
import TextInput from "components/app/function/TextInput";
import NumberInput from "components/app/function/NumberInput";
import useUrlString from "pages/business-suite/useUrlString";
import DailogAdddModifier from "pages/business-suite/dialog/DailogAdddModifier";
import DailogAddProductRecommended from "pages/business-suite/dialog/DailogAddProductRecommended";
import DailogAddProductAlternative from "pages/business-suite/dialog/DailogAddProductAlternative";
interface DialogProps {
  onUploadSuccess: ({ res, name }: { res: any; name: string }) => void;
  editItemShopProduct: any;
  isApiEditAndAddProduct: boolean;
  loadingFetchDataProductDetail: boolean;
  defaultDataProduct: boolean;
  isDialogOpenEditProducts: boolean;
  setIsDialogOpenEditProducts: (value: boolean) => void;
  setEditItemShopProduct: (value: any) => void;
  setIsApiEditAndAddProduct: (value: boolean) => void;
  itemGroups: any;
  id: any;
  setId: (value: any) => void;
  editItemCategories: any;
  setProductDatas: any;
  setOpenPopoverIndex: any;
  setIsDailogUploadProducts: (value: boolean) => void;
}
export default function PageEditProducts({
  onUploadSuccess,
  editItemShopProduct,
  isDialogOpenEditProducts,
  setIsDialogOpenEditProducts,
  setEditItemShopProduct,
  isApiEditAndAddProduct,
  setIsApiEditAndAddProduct,
  itemGroups,
  id,
  setId,
  defaultDataProduct,
  loadingFetchDataProductDetail,
  setOpenPopoverIndex,
  setIsDailogUploadProducts,
}: DialogProps) {
  //*==================Store Glogbal State===============
  const { showDialogConfirm } = appStore();
  //*===============Function==================
  const clearData = () => {
    setFormData({
      local_description: "",
      unit_price: "",
      unit_price_l: "",
      unit_price_m: "",
      unit_price_xl: "",
      unit_price_to: "",
      product_no: "",
      alias_no: "",
      min_order: "",
      production_lead_time: "",
      specification: "",
      support: "",
      remark: "",
    });
    setSelectedType("");
    setMarketplaces("");
    setSelectedSale("");
    setSelectedUnits("");
    setSelectedGroup("");
    setModifier([]);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string) => {
    setFormData((prev) => ({ ...prev, [key]: e.target.value }));
  };
  const onSubmitDeleteProdcuts = async () => {
    try {
      setLoadingSubmitDelete(true);
      let url: string = "";
      productIds.current.push(editItemShopProduct.id);
      url = RouteApi.submitDeleteShopProducts;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        product_ids: productIds.current,
        product_group_id: editItemShopProduct.product_group_id,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setOpenPopoverIndex(null);

            setLoadingSubmitDelete(false);
            onUploadSuccess({
              res: responses.user_shop_product,
              name: "delete",
            });
            setIsDialogOpenEditProducts(false);
            clearData();
          } else {
            setLoadingSubmitDelete(false);
          }
          // setLoadingSubmit(false);
        })
        .catch((err) => {
          setLoadingSubmitDelete(false);
        });
      // setLoadingSubmit(false);
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeleteProdcuts]`,
        status: StatusMsg.error,
        error,
      });
      // setLoadingSubmit(false);
    }
  };
  const { hanleClickRemoveURl } = useUrlString();
  const onSubmitUpdateProdcuts = async () => {
    setLoadingSubmit(true);
    try {
      let url: string = "";
      url = isApiEditAndAddProduct !== true ? RouteApi.submitUpdateShopProduct : RouteApi.submitCreateShopProduct;
      url += `token=${token}`;

      const dataEdit = {
        shop_id: shopId,
        product_id: editItemShopProduct.id,
        product_group_id: selectedGroup,
        product: {
          ...formData,
          product_group_id: selectedGroup,
          product_type: selectedType,
          flag: selectedSale,
          unit_of_measure: selectedUnits,
          use_sugar: editItemShopProduct.use_sugar,
          use_size: editItemShopProduct.use_size,
          use_modifier: editItemShopProduct.use_modifier,
          allow_change_price: editItemShopProduct.allow_change_price,
          inactived: editItemShopProduct.inactived,
          allow_change_discount: editItemShopProduct.allow_change_discount,
          status: marketplaces,
        },
      };
      const dataAdd = {
        shop_id: shopId,
        product_group_id: id,
        product: {
          ...formData,
          product_group_id: id,
          product_type: selectedType,
          flag: selectedSale,
          unit_of_measure: selectedUnits,
          use_sugar: editItemShopProduct.use_sugar,
          use_size: editItemShopProduct.use_size,
          use_modifier: editItemShopProduct.use_modifier,
          allow_change_price: editItemShopProduct.allow_change_price,
          inactived: editItemShopProduct.inactived,
          allow_change_discount: editItemShopProduct.allow_change_discount,
          status: marketplaces,
        },
      };
      await RequestApi(url, {
        data: !isApiEditAndAddProduct ? dataEdit : dataAdd,
      })
        .then((responses) => {
          if (responses.status === "success") {
            setLoadingSubmit(false);
            setOpenPopoverIndex(null);
            hanleClickRemoveURl("product_id");
            onUploadSuccess({
              res: responses.user_shop_product,
              name: "editOrAdd",
            });
            setIsDialogOpenEditProducts(false);
            clearData();
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[onSubmitUpdateProdcuts]`,
        status: StatusMsg.error,
        error,
      });
      // setLoadingSubmit(false);
    } finally {
      setLoadingSubmit(false);
    }
  };
  const onSubmitDeleteModifier = async (id: any) => {
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopProductModifier;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        product_group_id: selectedGroup,
        product_id: editItemShopProduct.id,
        unid: id,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          setEditItemShopProduct((prevItemGroups: any) => {
            // Ensure modifiers is an array (convert from object or undefined)
            const modifiersArray = Array.isArray(prevItemGroups.modifiers) ? prevItemGroups.modifiers : [];

            // Remove the modifier with matching ID
            const updatedModifiers = modifiersArray.filter((item: any) => item.id !== responses.user_shop_product_modifier.id);

            return {
              ...prevItemGroups,
              modifiers: updatedModifiers, // Set filtered array
            };
          });
        })
        .catch((err) => {});
      setLoadingSubmitDelete(false);
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeleteModifier]`,
        status: StatusMsg.error,
        error,
      });
      setLoadingSubmitDelete(false);
    }
  };
  const onSubmitDeleteShopProductRecommended = async (id: any) => {
    setLoadingSubmitDeleteProductRecommeded(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopProductRecommended;
      url += `token=${token}`;
      const pyaload = {
        product_id: editItemShopProduct.product_id,
        shop_id: shopId,
        recommend_product_id: id,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        setLoadingSubmitDeleteProductRecommeded(false);

        setEditItemShopProduct((prevItemGroups: any) => {
          return {
            ...prevItemGroups,
            recommended_products: (prevItemGroups.recommended_products || []).filter((item: any) => !id.includes(item.product_id)),
          };
        });
      }
    } catch (error) {
      setLoadingSubmitDeleteProductRecommeded(false);

      AppLog.show({
        message: `[onSubmitDeleteShopProductRecommended]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  const onSubmitDeleteShopAlertiveProduct = async (id: any) => {
    setLoadingSubmitDeleteAlertProduct(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopProductAlternative;
      url += `token=${token}`;
      const pyaload = {
        product_id: editItemShopProduct.product_id,
        shop_id: shopId,
        alternative_product_id: id,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        setLoadingSubmitDeleteAlertProduct(false);
        if (response.status === "success") {
          setLoadingSubmitDeleteProductRecommeded(false);

          setEditItemShopProduct((prevItemGroups: any) => {
            return {
              ...prevItemGroups,
              alternative_products: (prevItemGroups.alternative_products || []).filter((item: any) => !id.includes(item.product_id)),
            };
          });
        }
      }
    } catch (error) {
      setLoadingSubmitDeleteAlertProduct(false);

      AppLog.show({
        message: `[onSubmitDeleteShopAlertiveProduct]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  //*===============Variable==================
  const productIds = useRef<number[]>([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [idRecommendedDelete, setIdRecommendedDelete] = useState(null);
  const [idAlertiveProductDelete, setIdAlertiveProductDelete] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [marketplaces, setMarketplaces] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedSale, setSelectedSale] = useState("");
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [isDailogAddModifier, setisDailogAddModifier] = useState<boolean>(false);
  const [isDailogAddProductRecommended, setIsDailogAddProductRecommended] = useState<boolean>(false);
  const [isDailogAddProductAlernativer, setIsDailogAddProductAlernativer] = useState<boolean>(false);
  const [loadingSubmitDelete, setLoadingSubmitDelete] = useState<boolean>(false);
  const [selectedUnits, setSelectedUnits] = useState("");
  const [modifier, setModifier] = useState<any>([]);
  const [formData, setFormData] = useState({
    local_description: "",
    unit_price: "",
    unit_price_l: "",
    unit_price_m: "",
    unit_price_xl: "",
    unit_price_to: "",
    min_order: "",
    product_no: "",
    alias_no: "",
    production_lead_time: "",
    specification: "",
    support: "",
    remark: "",
  });
  const [loadingSubmitDeleteProductRecommeded, setLoadingSubmitDeleteProductRecommeded] = useState<boolean>(false);
  const [loadingSubmitDeleteAlertProduct, setLoadingSubmitDeleteAlertProduct] = useState<boolean>(false);
  //*===============Ueffect==================
  useEffect(() => {
    setSelectedType("Product");
    setMarketplaces("Unpublished");
    setSelectedUnits("PCS");
    setSelectedSale("None");
  }, [isDialogOpenEditProducts]);
  useEffect(() => {
    if (itemGroups?.data?.length) {
      setId(itemGroups.data[0].product_group_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (editItemShopProduct?.modifiers) {
      setModifier(editItemShopProduct.modifiers);
    }
    if (editItemShopProduct?.flag) {
      setSelectedSale(editItemShopProduct.flag);
    }
    if (editItemShopProduct?.product_group_id) {
      setSelectedGroup(editItemShopProduct.product_group_id);
    }

    if (editItemShopProduct?.unit_of_measure) {
      setSelectedUnits(editItemShopProduct.unit_of_measure);
    }
    if (editItemShopProduct?.status) {
      setMarketplaces(editItemShopProduct.status);
    }
    if (editItemShopProduct?.product_type) {
      setSelectedType(editItemShopProduct.product_type);
    }
  }, [editItemShopProduct]);
  const { token } = useAppSelector((state) => state.auth);
  useEffect(() => {
    if (defaultDataProduct === true) {
      if (editItemShopProduct) {
        setFormData({
          local_description: editItemShopProduct.local_description || "",
          unit_price: editItemShopProduct.unit_price || "",
          unit_price_l: editItemShopProduct.unit_price_l || "",
          unit_price_m: editItemShopProduct.unit_price_m || "",
          unit_price_xl: editItemShopProduct.unit_price_xl || "",
          unit_price_to: editItemShopProduct.unit_price_to || "",
          product_no: editItemShopProduct.product_no || "",
          alias_no: editItemShopProduct.alias_no || "",
          min_order: editItemShopProduct.min_order || "",
          production_lead_time: editItemShopProduct.production_lead_time || "",
          specification: editItemShopProduct.specification || "",
          support: editItemShopProduct.support || "",
          remark: editItemShopProduct.remark || "",
        });
      }
    }
  }, [defaultDataProduct, editItemShopProduct]);

  return (
    <>
      <div>
        <div className="lg:max-w-[1000px] md:max-w-[800px] h-[calc(100vh-80px)] custom-dialog-class flex flex-col justify-between">
          {loadingSubmit && <div className=" rounded-md flex items-center justify-center w-full h-full absolute top-0 left-0 z-10"></div>}
          {loadingSubmitDelete && <div className=" flex items-center justify-center w-full h-full absolute top-0 left-0 z-10"></div>}
          {/* bg-black/50 */}
          <div>
            <div className="flex items-center justify-between ">
              <div className="flex flex-col gap-2 absolute left-3 top-[12px]">
                <div className="text-lg font-bold">{isApiEditAndAddProduct !== true ? "Edit Product or Service Information" : "Create New Product or Service Information"}</div>
                <div>Input group description and choose the category, click "Save" when you finished.</div>
              </div>
              {isApiEditAndAddProduct === true && (
                <label
                  onClick={() => {
                    setIsDailogUploadProducts(true);
                    setOpenPopoverIndex(null);
                    // setisDialogOpenAddAndEditStaff(false);
                  }}
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all  absolute right-3 top-[12px]  duration-300 me-[50px] font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <ImageUp />
                </label>
              )}
            </div>
            <div
              className="absolute flex items-center justify-center right-3 top-[12px] z-40 cursor-pointer rounded-full bg-accent hover:text-accent-foreground lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 border border-gray-300 "
              onClick={() => {
                setIsDialogOpenEditProducts(false);
                clearData();
                setIsApiEditAndAddProduct(false);
                setId(id);
                setOpenPopoverIndex(null);
                const url = new URL(window.location.href);
                url.searchParams.delete("product_id");
                window.history.pushState({}, "", url.toString());
              }}
            >
              <X />
            </div>
          </div>
          {loadingFetchDataProductDetail ? (
            <>
              <div className="h-[80vh] mt-8 overflow-hidden">
                <ShimmerDialogEditProduct />
              </div>
            </>
          ) : (
            <>
              <ScrollArea className="mt-8 gap-3  pr-[20px] pb-[50px]">
                <div className="flex flex-col h-full py-4 px-1">
                  {/* Title */}

                  {/* Description */}
                  <div>
                    <label htmlFor="local_description" className="block mb-1 text-md font-medium">
                      Description
                    </label>
                    <Textarea value={formData.local_description} onChange={(e) => handleChange(e, "local_description")} rows={4} />
                  </div>
                  {/* Price Fields */}
                  <div className="mt-4 bg-gray-100 dark:bg-[#1e293b]   px-2 py-3 rounded-md">
                    <label className="block mb-1 text-md font-medium">Group</label>

                    <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2">
                      {itemGroups?.data?.map((group: any) => (
                        <button
                          key={group?.product_group_id ?? group?.id} // Use a valid key fallback
                          onClick={() => {
                            setSelectedGroup(group?.product_group_id);
                            setId(group?.product_group_id);
                          }}
                          className={`border px-4 py-1.5 rounded-lg text-sm font-semibold ${
                            id === group?.product_group_id ? "bg-blue-600 text-white" : " dark:bg-transparent border border-gray-300"
                          }`}
                        >
                          <p className="text-md font-semibold line-clamp-2 overflow-hidden">{group?.local_description ?? "No Description"} </p>
                        </button>
                      ))}
                    </div>
                  </div>
                  {/* Type Selection */}
                  <div className="mt-4 bg-gray-100 dark:bg-[#1e293b] px-2 py-3 rounded-md">
                    <label className="block mb-1 text-md font-medium">Type</label>
                    <div className="flex space-x-3">
                      <button
                        onClick={() => setSelectedType("Product")}
                        className={`px-4 py-1.5 rounded-lg text-sm font-semibold  ${
                          selectedType === "Product" ? "bg-blue-600 text-white" : "drak:bg-white  border border-gray-300"
                        }`}
                      >
                        Product
                      </button>
                      <button
                        onClick={() => setSelectedType("Coupon")}
                        className={`px-4 py-1.5 rounded-lg text-sm font-semibold  ${
                          selectedType === "Coupon" ? "bg-blue-600 text-white " : "drak:bg-white  border border-gray-300"
                        }`}
                      >
                        Coupon
                      </button>
                    </div>
                  </div>
                  {/* Sales Category */}
                  <div className="mt-4 bg-gray-100 dark:bg-[#1e293b]   px-2 py-3 rounded-md">
                    <label className="block mb-1 text-md font-medium">Sales</label>
                    <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2">
                      {["Today Deal", "Recommendation", "Flash Deal", "Hot Sales", "New Arrival", "Up Coming", "Out of Stock", "None"].map((sale) => (
                        <button
                          key={sale}
                          onClick={() => setSelectedSale(sale)} // Update selected sale
                          className={` border  px-4 py-1.5 rounded-lg text-sm font-semibold ${
                            selectedSale === sale ? "bg-blue-600 text-white" : "drak:bg-white  border border-gray-300" // Apply active style
                          }`}
                        >
                          {sale}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Unit of Measure */}
                  <div className="mt-4 bg-gray-100 dark:bg-[#1e293b]  rounded-md p-2">
                    <label className="block mb-1 text-md font-medium">Unit of Measure</label>
                    <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2">
                      {["PCS", "GRAM", "KG", "METER", "BOX", "CTN", "BOTTLE", "PACK", "LITRE", "PAIR", "ROLL", "TON", "UNIT", "HOUR"].map((unit) => (
                        <button
                          key={unit}
                          onClick={() => setSelectedUnits(unit)} // Toggle unit selection
                          className={`px-4 py-1.5 rounded-lg text-sm font-semibold ${selectedUnits === unit ? "bg-blue-600 text-white" : "drak:bg-white  border border-gray-300"}`} // Highlight selected units
                        >
                          {unit}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="grid lg:grid-cols-4 md:grid-cols-3 gird-cols-2 space-x-2 mt-4">
                    <div className="">
                      <label htmlFor="product_no" className="block mb-1 text-md font-medium">
                        Item No.
                      </label>
                      <TextInput value={formData.product_no} onChange={(e) => handleChange(e, "product_no")} placeholder="" />
                    </div>
                    <div className="">
                      <label htmlFor="alias_no" className="block mb-1 text-md font-medium">
                        Barcode
                      </label>
                      <TextInput value={formData.alias_no} onChange={(e) => handleChange(e, "alias_no")} />
                    </div>
                    <div className="">
                      <label htmlFor="unit_price" className="block mb-1 text-md font-medium">
                        MOQ
                      </label>
                      <TextInput value={formData.min_order} onChange={(e) => handleChange(e, "min_order")} />
                    </div>
                    <div className="">
                      <label htmlFor="production_lead_time" className="block mb-1 text-md font-medium">
                        Production Lead Time (D)
                      </label>
                      <TextInput value={formData.production_lead_time} onChange={(e) => handleChange(e, "production_lead_time")} />
                    </div>
                  </div>

                  <div className=" mt-2">
                    <label htmlFor="specification" className="block mb-2 text-md font-medium ">
                      Specification
                    </label>
                    <Textarea value={formData.specification} onChange={(e) => handleChange(e, "specification")} rows={2} />
                  </div>
                  <div className="mt-2">
                    <label htmlFor="support" className="block mb-2 text-md font-medium ">
                      Support
                    </label>
                    <Textarea value={formData.support} onChange={(e) => handleChange(e, "support")} rows={2} />
                  </div>
                  <div className="mt-2  ">
                    <label htmlFor="remark" className="block mb-2 text-md font-medium ">
                      Remark
                    </label>
                    <Textarea value={formData.remark} onChange={(e) => handleChange(e, "remark")} rows={2} />
                  </div>
                  {editItemShopProduct?.use_size === "Yes" ? (
                    <div className="grid grid-cols-4 space-x-2 mt-4">
                      <div className="">
                        <label htmlFor="unit_price" className="block mb-1 text-md font-medium">
                          Unit Price (S)
                        </label>
                        <NumberInput id="unit_price" value={formData.unit_price} onChange={(e) => handleChange(e, "unit_price")} />
                      </div>
                      <div className="">
                        <label htmlFor="unit_price_m" className="block mb-1 text-md font-medium">
                          Unit Price (M)
                        </label>
                        <NumberInput id="unit_price_m" value={formData.unit_price_m} onChange={(e) => handleChange(e, "unit_price_m")} />
                      </div>

                      <div className="">
                        <label htmlFor="unit_price_l" className="block mb-1 text-md font-medium">
                          Unit Price (L)
                        </label>
                        <NumberInput value={formData.unit_price_l} onChange={(e) => handleChange(e, "unit_price_l")} />
                      </div>
                      <div className="">
                        <label htmlFor="unit_price_xl" className="block mb-1 text-md font-medium">
                          Unit Price (XL)
                        </label>
                        <NumberInput id="unit_price_xl" value={formData.unit_price_xl} onChange={(e) => handleChange(e, "unit_price_xl")} />
                      </div>
                    </div>
                  ) : (
                    <div className="grid grid-cols-4 space-x-2 mt-4">
                      <div className="">
                        <label htmlFor="unit_price" className="block mb-1 text-md font-medium">
                          Unit Price
                        </label>
                        <NumberInput value={formData.unit_price} onChange={(e) => handleChange(e, "unit_price")} />
                      </div>
                      <div className="">
                        <label htmlFor="unit_price_to" className="block mb-1 text-md font-medium">
                          Unit Price (Max.)
                        </label>
                        <NumberInput value={formData.unit_price_to} onChange={(e) => handleChange(e, "unit_price_to")} />
                      </div>
                    </div>
                  )}
                  {/* Option & Permission----------------------------- */}
                  <div className=" mt-2">
                    <h2 className="text-xl font-semibold  mt-2">Option & Permission</h2>

                    {/* Setting Options */}
                    <div className="space-y-3 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2  ">
                      <div className=" mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                        <SwitchYesNoWithLabel
                          id="allow_change_use_sugar"
                          label="Choose Sugar Option"
                          value={isApiEditAndAddProduct !== true ? editItemShopProduct?.use_sugar : "No"}
                          onChange={(value) => {
                            const tmpUserSetting = { ...editItemShopProduct };
                            tmpUserSetting.use_sugar = value;
                            setEditItemShopProduct(tmpUserSetting);
                          }}
                        />
                      </div>
                      <div className=" bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                        <SwitchYesNoWithLabel
                          id="use_size"
                          label="Choose Size Option"
                          value={isApiEditAndAddProduct !== true ? editItemShopProduct?.use_size : "No"}
                          onChange={(value) => {
                            // setValueOption(value);
                            const tmpUserSetting = { ...editItemShopProduct };
                            tmpUserSetting.use_size = value;
                            setEditItemShopProduct(tmpUserSetting);
                          }}
                        />
                      </div>
                      <div className=" bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                        <SwitchYesNoWithLabel
                          id="allow_change_modifier_option"
                          label="Choose Modifier Option"
                          value={isApiEditAndAddProduct !== true ? editItemShopProduct?.use_modifier : "No"}
                          onChange={(value) => {
                            // setValueOption(value);
                            const tmpUserSetting = { ...editItemShopProduct };
                            tmpUserSetting.use_modifier = value;
                            setEditItemShopProduct(tmpUserSetting);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className=" mt-2">
                    {/* <h2 className="text-xl font-semibold mb-3 mt-2">Permission</h2> */}
                    <div className="space-y-3 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2">
                      <div className=" mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                        <SwitchYesNoWithLabel
                          id="allow_change_price"
                          label="Allow Change Price"
                          value={isApiEditAndAddProduct !== true ? editItemShopProduct?.allow_change_price : "No"}
                          onChange={(value) => {
                            const tmpUserSetting = { ...editItemShopProduct };
                            tmpUserSetting.allow_change_price = value;
                            setEditItemShopProduct(tmpUserSetting);
                          }}
                        />
                      </div>
                      <div className="bg-gray-100   dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                        <SwitchYesNoWithLabel
                          id="allow_change_discount"
                          label="Allow Change Discount"
                          value={isApiEditAndAddProduct !== true ? editItemShopProduct?.allow_change_discount : "No"}
                          onChange={(value) => {
                            const tmpUserSetting = { ...editItemShopProduct };
                            tmpUserSetting.allow_change_discount = value;
                            setEditItemShopProduct(tmpUserSetting);
                          }}
                        />
                      </div>
                      <div className="  bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                        <SwitchYesNoWithLabel
                          id="inactive_product_service"
                          label="Inactive Product/Service"
                          value={isApiEditAndAddProduct !== true ? editItemShopProduct?.inactived : "No"}
                          onChange={(value) => {
                            const tmpUserSetting = { ...editItemShopProduct };
                            tmpUserSetting.inactived = value;
                            setEditItemShopProduct(tmpUserSetting);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <h2 className="text-xl font-semibold mb-3 mt-4">Marketplaces</h2>
                  <div className="bg-gray-100 dark:bg-[#1e293b] px-2 py-3 rounded-md ">
                    <label className="block mb-1 text-md font-medium">Store</label>
                    <div className="flex space-x-3">
                      <button
                        onClick={() => setMarketplaces("Unpublished")}
                        className={`border  px-4 py-1.5 rounded-lg text-sm font-semibold
                     ${marketplaces === "Unpublished" ? "bg-blue-600 text-white  " : " bg-transparent  border-gray-300"} `}
                      >
                        Unpublished
                      </button>
                      <button
                        onClick={() => setMarketplaces("Published")}
                        className={` border  px-4 py-1.5 rounded-lg text-sm font-semibold
                     ${marketplaces === "Published" ? "bg-blue-600 text-white " : " bg-transparent  border-gray-300 "} `}
                      >
                        Published
                      </button>
                    </div>
                  </div>
                  {/* ----------------------------- */}
                  {isApiEditAndAddProduct !== true ? (
                    <>
                      <div className="flex items-center justify-between mt-4 ">
                        <h2 className="text-xl font-semibold mb-3 mt-4">Recommended Products</h2>
                      </div>
                      <div className="grid grid-cols-5  gap-y-3 gap-x-2 ">
                        {editItemShopProduct?.recommended_products?.map((item: any, index: number) => {
                          return (
                            <div className={`relative z-1 w-full max-w-sm border rounded-lg cursor-pointer`}>
                              <label
                                className="absolute opacity-80 p-1 mx-auto z-50 top-2 right-2 text-white group bg-red-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                              >
                                {loadingSubmitDeleteProductRecommeded === true && idRecommendedDelete === item.product_id ? (
                                  <Loader className="animate-spin w-4 h-4" />
                                ) : (
                                  <Minus
                                    onClick={() => {
                                      setIdRecommendedDelete(item.product_id);

                                      onSubmitDeleteShopProductRecommended(item.product_id);
                                    }}
                                    className="w-4 h-4"
                                  />
                                )}
                              </label>
                              <div className=" w-full relative overflow-hidden aspect-square  ">
                                <ImageUrl className="rounded-t-md cursor-pointer w-full h-full object-cover " src={item.picture} alt="" />
                              </div>
                              <div className={`p-4 `}>
                                <h5 className="text-md font-semibold line-clamp-1 overflow-hidden  ">{item?.local_description}</h5>
                                <p className=" font-semibold text-lg  text-red-500 "> {item.unit_price}</p>
                              </div>
                            </div>
                          );
                        })}
                        <div
                          onClick={() => setIsDailogAddProductRecommended(true)}
                          className={`h-[270px] flex items-center justify-center w-full max-w-sm  rounded-lg cursor-pointer  border border-gray-200 bg-gray-100 dark:bg-black`}
                        >
                          <label
                            className=" p-1 mx-auto z-50 top-2 right-2 text-white group bg-blue-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                          >
                            <Plus className="text-sm cursor-pointer  dark:text-white" />
                          </label>
                        </div>
                      </div>

                      {/* //------------------------------------------- */}
                      <div className="flex items-center justify-between mt-2 ">
                        <h2 className="text-xl font-semibold mb-3 mt-4">Alertnative Products</h2>
                      </div>
                      <div className="grid grid-cols-5  gap-y-3 gap-x-2 ">
                        {editItemShopProduct?.alternative_products?.map((item: any, index: number) => {
                          return (
                            <div className={`relative z-1 w-full max-w-sm border rounded-lg cursor-pointer`}>
                              <label
                                className="absolute opacity-80 p-1 mx-auto z-50 top-2 right-2 text-white group bg-red-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                              >
                                {loadingSubmitDeleteAlertProduct === true && idAlertiveProductDelete === item.product_id ? (
                                  <Loader className="animate-spin w-4 h-4" />
                                ) : (
                                  <Minus
                                    onClick={() => {
                                      setIdAlertiveProductDelete(item.product_id);
                                      onSubmitDeleteShopAlertiveProduct(item.product_id);
                                    }}
                                    className="w-4 h-4"
                                  />
                                )}
                              </label>
                              <div className=" w-full relative overflow-hidden aspect-square  ">
                                <ImageUrl className="rounded-t-md cursor-pointer w-full h-full object-cover " src={item.picture} alt="" />
                              </div>
                              <div className={`p-4 `}>
                                <h5 className="text-md font-semibold line-clamp-1 overflow-hidden  ">{item?.local_description}</h5>
                                <p className=" font-semibold text-lg  text-red-500 "> {item.unit_price}</p>
                              </div>
                            </div>
                          );
                        })}
                        <div
                          onClick={() => setIsDailogAddProductAlernativer(true)}
                          className={`h-[270px] flex items-center justify-center w-full max-w-sm  rounded-lg cursor-pointer  border border-gray-200 bg-gray-100 dark:bg-black`}
                        >
                          <label
                            className=" p-1 mx-auto z-50 top-2 right-2 text-white group bg-blue-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                          >
                            <Plus className="text-sm cursor-pointer  dark:text-white" />
                          </label>
                        </div>
                      </div>
                      {/* //------------------------------------- */}
                      <div className="flex items-center justify-between mt-2 ">
                        <h2 className="text-xl font-semibold mb-3 mt-4">Modifier Option</h2>
                        <button onClick={() => setisDailogAddModifier(true)} className=" rounded-full bg-blue-600 w-8 h-8 flex justify-center items-center">
                          <Plus className="text-sm cursor-pointer text-white" />
                        </button>
                      </div>

                      <div className="w-full grid grid-cols-6 gap-2 mt-2">
                        {modifier?.map((group: any, index: number) => (
                          <div
                            key={index}
                            className={` transition-all  py-2 mt-2 border border-gray-300 rounded-lg flex items-center gap-2 justify-between pe-2 ps-3 group 
                             `}
                          >
                            <p className="text-md  line-clamp-2 px-2 overflow-hidden font-semibold ">{group?.local_description ?? "No Description"}</p>
                            <div className="">
                              <Trash2
                                onClick={(event) => {
                                  event.stopPropagation();
                                  showDialogConfirm({
                                    titileButtonSubmit: "Yes, Delete",
                                    titileButtonCancel: "No, Cancel",
                                    title: "Delete",
                                    message: "Do you want to delete ?",
                                    onSubmit() {
                                      onSubmitDeleteModifier(group.id);
                                    },
                                  });
                                }}
                                className=" text-xs opacity-0 group-hover:opacity-100 text-red-500 cursor-pointer w-5 h-5 "
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <ScrollBar orientation="vertical" />
              </ScrollArea>
            </>
          )}

          <div className="flex justify-between gap-3 pr-[20px] items-center px-4  left-0 w-full">
            {isApiEditAndAddProduct !== true ? (
              <>
                <button
                  onClick={() =>
                    showDialogConfirm({
                      titileButtonSubmit: "Yes, Delete",
                      titileButtonCancel: "No, Cancel",
                      title: "Delete",
                      message: "Do you want to delete ?",
                      onSubmit() {
                        onSubmitDeleteProdcuts();
                      },
                    })
                  }
                  className="w-full mt-6   bg-red-500 text-white text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
                >
                  {loadingSubmitDelete ? <Loader className="animate-spin" /> : "Delete"}
                </button>
                <button
                  onClick={() => {
                    onSubmitUpdateProdcuts();
                  }}
                  className="w-full mt-6 flex items-center justify-center  bg-blue-500 text-white text-lg py-2 rounded-lg"
                >
                  {loadingSubmit ? <Loader className="animate-spin" /> : "Save"}
                </button>
              </>
            ) : (
              <button
                onClick={() => {
                  onSubmitUpdateProdcuts();
                }}
                className="w-full mt-6 flex items-center justify-center  bg-blue-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
              >
                {loadingSubmit ? <Loader className="animate-spin" /> : "Save"}
              </button>
            )}
          </div>
        </div>
      </div>

      <DailogAdddModifier
        setEditItemShopProduct={setEditItemShopProduct}
        isDailogAddModifier={isDailogAddModifier}
        setisDailogAddModifier={setisDailogAddModifier}
        editItemShopProduct={editItemShopProduct}
        id={id}
      />

      <DailogAddProductRecommended
        isDailogAddProductRecommended={isDailogAddProductRecommended}
        setIsDailogAddProductRecommended={setIsDailogAddProductRecommended}
        editItemShopProduct={editItemShopProduct}
        setEditItemShopProduct={setEditItemShopProduct}
      />

      <DailogAddProductAlternative
        isDailogAddProductAlernativer={isDailogAddProductAlernativer}
        setIsDailogAddProductAlernativer={setIsDailogAddProductAlernativer}
        editItemShopProduct={editItemShopProduct}
        setEditItemShopProduct={setEditItemShopProduct}
      />
    </>
  );
}
